import React, { createContext } from 'react';
import { connect } from 'react-redux';

import { StoreState } from '@src/meta/types/store';
import { RoleAssignmentMap, Role, RoleAssignmentTarget } from '@modules/auth/components/types/user';
import { getRoleAssignmentMap } from '@modules/auth/components/lib/account';
import { isMaintenanceInProgress } from '@src/utils/maintenance';
import { CustomerAccountInfo } from '@modules/auth/components/types/customer-account';
import { hasAccessToBilling } from '@modules/auth/components/constants/accounts/access';

export type BillingContextProps = {
  readonly: boolean;
  maintenanceInProgress: boolean;
  hasAccess: boolean;
};

export const BillingContext = createContext<BillingContextProps>({
  readonly: false,
  maintenanceInProgress: false,
  hasAccess: false,
});

type Props = {
  children: React.ReactNode;
};

type PropsFromStore = {
  roleAssignments: RoleAssignmentMap | undefined;
  account: CustomerAccountInfo;
};

function hasReadonlyAccess(RoleAssignmentMap: RoleAssignmentMap | undefined) {
  return Boolean(
    (RoleAssignmentMap && RoleAssignmentMap.dbd === Role.APPLICATION_RO) ||
      isMaintenanceInProgress(RoleAssignmentTarget.DASHBOARD),
  );
}

function BillingContextProvider({ children, roleAssignments, account }: Props & PropsFromStore) {
  return (
    <BillingContext.Provider
      value={{
        readonly: hasReadonlyAccess(roleAssignments),
        maintenanceInProgress: isMaintenanceInProgress(RoleAssignmentTarget.DASHBOARD),
        hasAccess: hasAccessToBilling(account),
      }}
    >
      {children}
    </BillingContext.Provider>
  );
}

const mapStateToProps = (state: StoreState): PropsFromStore => {
  return {
    roleAssignments: getRoleAssignmentMap(state),
    account: state.account.account,
  };
};

export default connect(mapStateToProps)(BillingContextProvider);
